@if (control(); as control) {
  @if (field(); as field) {
    <div fxFlex fxLayout="column" fxLayoutGap="10px" class="iot-platform-ui-form-field__checkbox-container">
      <mat-checkbox
        [formControl]="control"
        data-cy="iot-platform-ui-checkbox-input"
        class="iot-platform-ui-form-field--{{ field.name?.() }} {{ field.inputCssClassName?.() }}"
        [fxFlex]="field.fxFlexOption?.() ? '0 1 calc(' + $safeNavigationMigration(field.fxFlexOption?.()) + ' - 10px)' : 'auto'"
        [fxFlex.lt-sm]="'100%'"
        (change)="field.selectionChange?.($event)"
        (click)="field.onClick?.($event)"
        [disabled]="$safeNavigationMigration(field.disabled?.())"
        [ngClass]="{ 'capitalize-first-letter': $safeNavigationMigration(field.capitalized?.()) }"
      >
        <div class="flex items-center justify-center">
          @if (field?.icon?.()) {
            <mat-icon [class]="field?.iconCssClassName?.()">{{ field?.icon?.() }}</mat-icon>
          }
          <span [class]="field?.cssClassName?.()">{{ $safeNavigationMigration(field.label?.()) | translate }}</span>
        </div>
      </mat-checkbox>

      @if (control?.invalid && control?.hasError('required')) {
        <mat-error class="fs-8">{{ 'FORM.ERROR_MESSAGE.REQUIRED' | translate }}</mat-error>
      } @else if (control?.invalid && field.error?.enabled?.() && field.error?.message?.()) {
        <mat-error class="fs-8">{{ $safeNavigationMigration(field.error?.message?.()) | translate }}</mat-error>
      }
    </div>
  }
}
